import React, { useEffect } from "react";
import { Modal, Button, Row, Col, Carousel } from "react-bootstrap";
import { SBSaveUpdateBtn } from "./Buttons/Buttons";
import sessionExpiredImage from '../../src/assets/images/Login/session-expired-img.svg';
import bg_img from '../assets/images/Login/login-img1.jpg';
import bg_img1 from '../assets/images/Login/login-img2.jpg';
import companyLogo from '../assets/images/Login/signin-company-logo.svg';
import { useNavigate } from "react-router-dom";
import companySmallLogo from '../assets/images/Sidebar/company-small-logo.svg';

const SessionExpiredModal = ({ show, onClose, message }) => {
    // const navigate = useNavigate();

    useEffect(() => {
        if (show) {
            const timeout = setTimeout(() => {
                sessionStorage.clear();
                window.location.href = '/';
            }, 10000); // 10 seconds

            return () => clearTimeout(timeout); // Cleanup timeout on unmount
        }
    }, [show]);

    const handleContinue = () => {
        sessionStorage.clear();
        window.location.href = '/';
    };
    return (
        // <Modal show={show} onHide={onClose} centered className='add-role-modal'>
        //     <Modal.Header closeButton>
        //         <Modal.Title>Session Expired</Modal.Title>
        //     </Modal.Header>
        //     <Modal.Body>
        //         <p>{message}</p>
        //     </Modal.Body>
        //     <Modal.Footer>
        //         <SBSaveUpdateBtn btnName="Ok" onClickEffect={onClose} />
        //     </Modal.Footer>
        // </Modal>

        <div className="signin-main-container">
            <Row className="lm-signin-login-row">
                <Col md={6} className="lm-signin-form-col verification-img-btn-col">
                    <div className="company-verification-content">
                        <img
                            src={companySmallLogo}
                            alt="Company Logo"
                            className='company-small-logo'
                        />
                        <span>Session Expired!</span>
                        <p>{message || "Your session has expired. Please log in again."}</p>
                    </div>

                    <div className="lm-login-form">
                        <div className="lm-login-form-btn verification-btn">
                            <img src={sessionExpiredImage} alt="Session Expired" />
                            <Button onClick={handleContinue}>Go to Sign In</Button>
                        </div>
                    </div>
                </Col>

                <Col md={6} className="lm-signin-image-col">
                    <Carousel style={{ width: "100%" }} controls={false} indicators={false}>
                        <Carousel.Item>
                            <div className="lm-bg-img-div">
                                <img src={bg_img} alt="background" className="lm-bg-img" />
                                <div className="carousel-content">
                                    <img src={companyLogo} alt="Company Logo" className="carousel-logo" />
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="lm-bg-img-div">
                                <img src={bg_img1} alt="background" className="lm-bg-img" />
                                <div className="carousel-content">
                                    <img src={companyLogo} alt="Company Logo" className="carousel-logo" />
                                </div>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </Col>
            </Row>
        </div>
    );
};

export default SessionExpiredModal;
